import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../../theme'
import LexiconItem from '../Item'

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);
  &:last-child {
    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  }
`
export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.m375_keyNumbers}
  position: sticky;
  inset-block-start: var(--g_height__header);
  flex: 0 0 auto;
  width: 1.75em;
  text-align: center;
  padding-block: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_keyNumbers}
    flex: 0 0 calc(100% / 3);
    width: auto;
    padding-block: ${pxToRem(40)};
  }
`
export const Items = styled.dl`
  margin: unset;
  border-inline-start: 1px solid rgba(0, 0, 0, 0.1);
  flex: 1 1 0;
  min-width: 0;
  align-self: stretch;
  @media ${mq(sizes.desktop)} {
    flex: 0 0 calc(100% / 3 * 2);
    max-width: calc(100% / 3 * 2);
  }
`
export const _LexiconItem = styled(LexiconItem)`
  &:not(:first-child) {
    border-block-start: 1px solid rgba(0, 0, 0, 0.1);
  }
`
